import React, { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import BuilderContext from '../../builder/hooks/context';
import Markup from '../../markup';
import { device } from '../../const/device';

function SwitchColorTheme(){
    const { builder } = useContext(BuilderContext);
    const tabletS = useMediaQuery({ query: `(${device.tabletS})` });
    const tablet = useMediaQuery({ query: `(${device.tablet})` });

    const onChengeColorTheme = () => {
        const changeColor = (builder.membersData.colorTheme == "black") ? 'white':'black';
        const SwitchCol = builder.membersData.updateColor(changeColor);
        window["builderChangeTheme"](changeColor);
        fetcSwitchColor(changeColor);
    }

    const fetcSwitchColor = async (switchColor:string) => {
        try{
            const ColorSwitch = await window["builderOnChangeColorTheme"](switchColor)
            return new Promise(resolve => {
                console.log(resolve);
            })
        }catch(e) {}
    }

    return(
        <>
            <Markup.BaseLayout.SwitchBox id={builder.membersData.colorTheme}/>
            { tablet || tabletS ? <Markup.BaseLayout.SwitchLabel position={'relative'} htmlFor="checkbox" onClick={onChengeColorTheme}/> :
                <Markup.BaseLayout.SwitchLabel position={'absolute'} htmlFor="checkbox" onClick={onChengeColorTheme}/>}
        </>
    );
}

export default React.memo(SwitchColorTheme);